import axios from 'axios'
import global from '../components/Global'
import qs from 'qs'
import { MessageBox, Message } from 'element-ui'

// create an axios instance
const service = axios.create({
  baseURL: global.domain, // url = base url + request url
  timeout: 5000, // request timeout
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// request interceptor
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');

    if (token) {
      if (config.method.toLowerCase() === 'post') {
        // Ensure config.data is an object before setting token
        if (!config.data) {
          config.data = {};
        }
        config.data.token = token;
      } else if (config.method.toLowerCase() === 'get') {
        // Ensure config.params is an object before setting token
        if (!config.params) {
          config.params = {};
        }
        config.params.token = token;
      }
    }

    // Stringify data if it's an object and method is POST
    if (config.method.toLowerCase() === 'post' && typeof config.data === 'object') {
      config.data = qs.stringify(config.data);
    }

    return config;
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.Result != 0) {
      Message({
        message: res.Message,
        type: 'error',
        duration: 5 * 1000
      })
      if (res.Result == '70001') {
        window.$vm.$router.push('/login')
      }
      return Promise.reject(new Error(res.Message || 'Error'))
    } else {
      // W3siaWQiOiI
      // 返回的res中，有可能是res.body.Data，有可能是res.Data是加密的，但是开头都是W3siaWQiOiI
      // 需要使用正则表达式找到该加密数据，进行解密后，再组装返回

      // 如果是res.body.Data匹配到W3siaWQiOiI，就在这个if中返回
      if (res.body && res.body.Data) {
        res.body.Data = JSON.parse(Base64.decode(res.body.Data));
      }
      // 如果是在res.Data中匹配到W3siaWQiOiI，就在这个if中返回
      if (res.Data) {
        if (typeof res.Data === 'string') {
          res.Data = JSON.parse(Base64.decode(res.Data));
        }
      }
      return res
    }

    // if (res.code !== 20000) {
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })

    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     // to re-login
    //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //       confirmButtonText: 'Re-Login',
    //       cancelButtonText: 'Cancel',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js